var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAztec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.421,
    x2: 385.452,
    y1: 76.421,
    y2: 385.452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 378.071,
    y2: 510.391
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.5,
    x2: 19.667,
    xlinkHref: "#lg1",
    y1: 185.5,
    y2: 19.667
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.667,
    x2: 105.18,
    xlinkHref: "#lg1",
    y1: 222.667,
    y2: 105.18
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.333,
    x2: 125.19,
    xlinkHref: "#lg1",
    y1: 261.333,
    y2: 125.19
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.552,
    x2: 226.552,
    xlinkHref: "#lg1",
    y1: 98.69,
    y2: 84.19
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(1 0 0 -1 0 171.167)",
    gradientUnits: "userSpaceOnUse",
    x1: 270.552,
    x2: 226.552,
    xlinkHref: "#lg1",
    y1: -240.143,
    y2: -254.643
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(0 1 -1 0 -554 1064)",
    gradientUnits: "userSpaceOnUse",
    x1: -793.448,
    x2: -837.448,
    xlinkHref: "#lg1",
    y1: -965.31,
    y2: -979.81
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(0 1 1 0 -725.167 1064)",
    gradientUnits: "userSpaceOnUse",
    x1: -793.448,
    x2: -837.448,
    xlinkHref: "#lg1",
    y1: 823.857,
    y2: 809.357
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -56.638 646.737)",
    gradientUnits: "userSpaceOnUse",
    x1: -41.087,
    x2: -85.087,
    xlinkHref: "#lg1",
    y1: -653.672,
    y2: -668.172
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.707 .707 .707 -.707 -177.672 767.771)",
    gradientUnits: "userSpaceOnUse",
    x1: -41.087,
    x2: -85.087,
    xlinkHref: "#lg1",
    y1: 512.219,
    y2: 497.719
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -1200.737 1007.362)",
    gradientUnits: "userSpaceOnUse",
    x1: -1545.81,
    x2: -1589.81,
    xlinkHref: "#lg1",
    y1: -653.672,
    y2: -668.172
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1321.771 886.328)",
    gradientUnits: "userSpaceOnUse",
    x1: -1545.81,
    x2: -1589.81,
    xlinkHref: "#lg1",
    y1: 512.219,
    y2: 497.719
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a96c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 125,
    x2: 284.138,
    xlinkHref: "#lg2",
    y1: 125,
    y2: 284.138
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 177,
    x2: 336.138,
    xlinkHref: "#lg2",
    y1: 73,
    y2: 232.138
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 73,
    x2: 232.138,
    xlinkHref: "#lg2",
    y1: 177,
    y2: 336.138
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.5,
    x2: 408.638,
    xlinkHref: "#lg2",
    y1: 0.5,
    y2: 159.638
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5,
    x2: 159.638,
    xlinkHref: "#lg2",
    y1: 249.5,
    y2: 408.638
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.391,
    x2: 269.529,
    xlinkHref: "#lg2",
    y1: 139.61,
    y2: 298.748
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.638,
    x2: 319.776,
    xlinkHref: "#lg2",
    y1: 89.362,
    y2: 248.501
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.016,
    x2: 257.154,
    xlinkHref: "#lg2",
    y1: 151.984,
    y2: 311.122
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_1_)",
    r: 255
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.237 330.066c32.049 104.194 129.057 179.934 243.763 179.934s211.714-75.74 243.763-179.934z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_3_)",
    r: 229.441
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_4_)",
    r: 145.988
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_5_)",
    r: 117.232
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m292.388 148.317 11.559 4.312-48.947-134.258-48.947 134.258 11.559-4.312c24.114-8.994 50.662-8.994 74.776 0z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.388 361.683 11.559-4.312-48.947 134.258-48.947-134.258 11.559 4.312c24.114 8.994 50.662 8.994 74.776 0z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m361.683 292.388-4.312 11.559 134.258-48.947-134.258-48.947 4.312 11.559c8.994 24.114 8.994 50.662 0 74.776z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.317 292.388 4.312 11.559-134.258-48.947 134.258-48.947-4.312 11.559c-8.994 24.114-8.994 50.662 0 74.776z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.873 206.001 5.124 11.222 60.324-129.545-129.545 60.324 11.222 5.124c23.412 10.691 42.185 29.464 52.875 52.875z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.001 356.873 11.222 5.124-129.545 60.325 60.324-129.545 5.124 11.222c10.691 23.411 29.464 42.184 52.875 52.874z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m303.999 356.873-11.222 5.124 129.545 60.324-60.324-129.545-5.124 11.222c-10.691 23.412-29.464 42.185-52.875 52.875z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.127 206.001-5.124 11.222-60.325-129.545 129.545 60.324-11.222 5.124c-23.411 10.691-42.184 29.464-52.874 52.875z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.581 86.419c-45.03-45.029-104.899-69.828-168.581-69.828-63.681 0-123.551 24.799-168.581 69.828-45.029 45.03-69.828 104.899-69.828 168.581s24.799 123.551 69.828 168.581c45.03 45.029 104.899 69.828 168.581 69.828s123.551-24.799 168.581-69.828c45.029-45.03 69.828-104.899 69.828-168.581s-24.799-123.551-69.828-168.581zm-3.123 318.702-32.475-70.249c7.837-12.999 13.818-27.235 17.584-42.339l72.582-26.69c-2.469 52.003-22.665 100.762-57.691 139.278zm-388.607-139.277 72.583 26.689c3.766 15.104 9.747 29.34 17.584 42.339l-32.476 70.249c-35.025-38.516-55.222-87.275-57.691-139.277zm57.691-160.966 32.476 70.249c-7.837 12.999-13.818 27.235-17.584 42.339l-72.583 26.689c2.469-52.001 22.666-100.76 57.691-139.277zm305.625 150.122c0 8.984-.86 17.77-2.483 26.289l-17.783 6.539c2.868-10.462 4.408-21.468 4.408-32.828s-1.54-22.366-4.408-32.828l17.783 6.539c1.623 8.519 2.483 17.305 2.483 26.289zm13.665-20.351 55.346 20.351-55.346 20.351c.877-6.662 1.335-13.454 1.335-20.351s-.459-13.689-1.335-20.351zm-75.12 136.271-17.177-7.941c19.314-11.05 35.395-27.131 46.445-46.446l7.941 17.178c-9.955 14.613-22.596 27.255-37.209 37.209zm44.418-21.614 24.781 53.605-53.605-24.781c10.82-8.307 20.517-18.004 28.824-28.824zm-123.13 45.861c-8.984 0-17.77-.86-26.289-2.483l-6.539-17.783c10.462 2.868 21.468 4.408 32.828 4.408s22.366-1.54 32.828-4.408l-6.539 17.783c-8.519 1.623-17.305 2.483-26.289 2.483zm20.351 13.665-20.351 55.346-20.351-55.346c6.662.877 13.454 1.335 20.351 1.335s13.689-.459 20.351-1.335zm-136.271-75.121 7.941-17.178c11.05 19.314 27.13 35.395 46.445 46.445l-17.177 7.941c-14.614-9.953-27.255-22.595-37.209-37.208zm21.614 44.418-53.604 24.782 24.781-53.605c8.306 10.82 18.003 20.517 28.823 28.823zm-45.861-123.129c0-8.984.86-17.77 2.483-26.289l17.783-6.539c-2.868 10.462-4.408 21.468-4.408 32.828s1.54 22.366 4.408 32.828l-17.783-6.539c-1.623-8.519-2.483-17.305-2.483-26.289zm-13.664 20.352-55.346-20.352 55.346-20.352c-.877 6.662-1.335 13.454-1.335 20.352s.458 13.689 1.335 20.352zm75.12-136.272 17.178 7.941c-.129.074-.26.146-.389.221-.506.228-.984.512-1.428.845-8.171 4.86-15.743 10.624-22.57 17.163-.473.362-.905.781-1.285 1.255-8.089 7.973-15.096 17.039-20.773 26.962l-7.941-17.178c9.953-14.614 22.595-27.255 37.208-37.209zm-44.418 21.614-24.781-53.605 53.605 24.781c-10.821 8.307-20.518 18.004-28.824 28.824zm123.129-45.861c8.984 0 17.77.86 26.289 2.483l6.539 17.783c-10.462-2.868-21.468-4.408-32.828-4.408s-22.366 1.54-32.829 4.408l6.539-17.783c8.519-1.623 17.306-2.483 26.29-2.483zm-20.352-13.665 20.352-55.346 20.351 55.346c-6.662-.877-13.454-1.335-20.351-1.335-6.898 0-13.69.459-20.352 1.335zm106.54 220.987v-24.066c0-3.578 1.58-6.873 4.227-8.813l16.656-12.212c-3.444 16.736-10.728 32.086-20.883 45.091zm23.121-67.155c0 .615-.013 1.226-.023 1.839l-27.74 20.34c-6.485 4.755-10.357 12.572-10.357 20.91v39.792c-19.14 16.462-44.021 26.427-71.188 26.427-27.166 0-52.047-9.965-71.187-26.427v-39.792c0-8.338-3.872-16.155-10.358-20.911l-27.74-20.339c-.01-.612-.023-1.224-.023-1.839 0-28.999 11.354-55.393 29.846-74.979 22.929 8.71 50.911 13.479 79.462 13.479 28.989 0 56.334-4.65 79.466-13.475 18.489 19.586 29.842 45.978 29.842 74.975zm-216.379 22.063 16.655 12.211c2.647 1.941 4.228 5.236 4.228 8.814v24.066c-10.155-13.004-17.439-28.354-20.883-45.091zm107.07-98.563c-23.788 0-47.038-3.498-66.828-9.938 2.962-2.295 6.044-4.44 9.236-6.427 18.047 4.441 37.402 6.695 57.592 6.695s39.545-2.254 57.592-6.695c3.192 1.987 6.275 4.132 9.236 6.427-19.79 6.44-43.039 9.938-66.828 9.938zm-34.622-27.186c10.885-3.644 22.526-5.623 34.622-5.623s23.737 1.979 34.622 5.623c-11.209 1.645-22.89 2.516-34.622 2.516-11.733 0-23.413-.87-34.622-2.516zm78.579-29.413c6.577 2.177 12.939 4.828 19.047 7.915l-13.792 6.376zm-93.169 14.29-13.792-6.376c6.108-3.086 12.47-5.738 19.047-7.915zm-69.596 69.597-14.291 5.255c2.178-6.577 4.829-12.939 7.915-19.047zm0 98.424-6.376 13.792c-3.086-6.108-5.737-12.47-7.915-19.047zm69.596 69.596 5.255 14.292c-6.577-2.178-12.94-4.829-19.048-7.916zm98.424 0 13.793 6.376c-6.108 3.086-12.471 5.738-19.048 7.916zm69.597-69.596 14.291-5.255c-2.177 6.577-4.828 12.939-7.915 19.047zm0-98.424 6.376-13.792c3.086 6.107 5.737 12.47 7.915 19.047zm-10.83-12.321c-5.677-9.923-12.685-18.99-20.774-26.962-.38-.474-.813-.894-1.286-1.256-6.829-6.54-14.403-12.306-22.576-17.166-.441-.33-.914-.612-1.416-.838-.131-.075-.263-.149-.394-.224l17.178-7.941c14.614 9.954 27.255 22.596 37.209 37.209zm-13.673-61.597 53.605-24.781-24.781 53.605c-8.307-10.82-18.004-20.517-28.824-28.824zm-14.433-9.853c-12.999-7.837-27.235-13.818-42.339-17.584l-26.69-72.582c52.002 2.469 100.761 22.665 139.277 57.691zm-117.407-17.584c-15.104 3.766-29.339 9.747-42.338 17.584l-70.249-32.475c38.516-35.025 87.276-55.222 139.277-57.691zm-42.339 283.549c12.999 7.837 27.235 13.818 42.339 17.585l26.689 72.582c-52.002-2.469-100.761-22.665-139.277-57.691zm117.407 17.585c15.104-3.766 29.34-9.748 42.34-17.584l70.248 32.476c-38.516 35.026-87.275 55.222-139.277 57.691zm113.033-188.101c-3.766-15.104-9.747-29.34-17.584-42.339l32.475-70.249c35.026 38.516 55.222 87.275 57.691 139.277z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.5 101.5c12.682 0 23-10.317 23-23s-10.318-23-23-23-23 10.317-23 23 10.318 23 23 23zm0-31c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.5 408.5c-12.683 0-23 10.317-23 23s10.317 23 23 23 23-10.317 23-23-10.317-23-23-23zm0 31c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.5 55.5c-12.683 0-23 10.317-23 23s10.317 23 23 23 23-10.317 23-23-10.317-23-23-23zm0 31c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.5 408.5c-12.682 0-23 10.317-23 23s10.318 23 23 23 23-10.317 23-23-10.318-23-23-23zm0 31c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.5 182.5c0 12.683 10.317 23 23 23s23-10.317 23-23-10.317-23-23-23-23 10.317-23 23zm31 0c0 4.411-3.589 8-8 8s-8-3.589-8-8 3.589-8 8-8 8 3.589 8 8z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.5 304.5c-12.682 0-23 10.317-23 23s10.318 23 23 23 23-10.317 23-23-10.318-23-23-23zm0 31c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.5 304.5c-12.683 0-23 10.317-23 23s10.317 23 23 23 23-10.317 23-23-10.317-23-23-23zm0 31c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.5 205.5c12.682 0 23-10.317 23-23s-10.318-23-23-23-23 10.317-23 23 10.318 23 23 23zm0-31c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.751 233.972c0-18.195-14.803-32.999-32.999-32.999-18.195 0-32.999 14.804-32.999 32.999s14.803 32.999 32.999 32.999 32.999-14.804 32.999-32.999zm-50.997 0c0-9.925 8.074-17.999 17.999-17.999s17.999 8.074 17.999 17.999-8.074 17.999-17.999 17.999-17.999-8.075-17.999-17.999z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.247 200.973c-18.195 0-32.998 14.804-32.998 32.999s14.803 32.999 32.998 32.999 32.999-14.804 32.999-32.999-14.804-32.999-32.999-32.999zm0 50.998c-9.924 0-17.998-8.074-17.998-17.999s8.074-17.999 17.998-17.999c9.925 0 17.999 8.074 17.999 17.999s-8.074 17.999-17.999 17.999z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.998 277.47h-14.998-36-14.999c-17.368 0-31.499 14.13-31.499 31.498s14.13 31.499 31.499 31.499h9.328c3.767 9.385 12.954 16.033 23.67 16.033s19.903-6.648 23.67-16.033h9.328c17.368 0 31.499-14.131 31.499-31.499s-14.13-31.498-31.498-31.498zm-82.495 31.498c0-9.097 7.401-16.498 16.499-16.498h7.499v32.997h-7.499c-9.098 0-16.499-7.402-16.499-16.499zm49.497 32.532c-5.79 0-10.5-4.71-10.5-10.5v-38.53h21v38.53c0 5.79-4.71 10.5-10.5 10.5zm32.998-16.033h-7.498v-32.997h7.498c9.098 0 16.499 7.401 16.499 16.498s-7.401 16.499-16.499 16.499z",
    fill: "url(#SVGID_25_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAztec);
export default __webpack_public_path__ + "static/media/icon-aztec.c389ff3a0a0d679f3c1bff1ccb839748.svg";
export { ForwardRef as ReactComponent };